export const COLORS = {
  WAFFY_BLACK: "#000000",
  WAFFY_GRAY_900: "#283743",
  WAFFY_GRAY_800: "#404D58",
  WAFFY_GRAY_700: "#58646D",
  WAFFY_GRAY_400: "#9FA6AB",
};
